export default __webpack_public_path__ + "static/media/ckLandingPageCoverMobile.653d8821.png";